import { GetFieldType } from "./getType";

export const getValueByKey = <T, K extends keyof T>(value: T, key: K): T[K] => value[key];

export const getValue = <TData, TPath extends string, TDefault = GetFieldType<TData, TPath>>(
    data: TData,
    path: TPath,
    defaultValue?: TDefault
): GetFieldType<TData, TPath> | TDefault => {
    const value = path
        .split(/[.[\]]/)
        .filter(Boolean)
        .reduce<GetFieldType<TData, TPath>>(
            // eslint-disable-next-line
            (value, key) => (value as any)?.[key],
            // eslint-disable-next-line
            data as any
        );

    return value !== undefined ? value : (defaultValue as TDefault);
};
